import React, { PureComponent } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { onlyNumbers } from "utils/normalize";
import {
  required,
  isNumEqual9,
  isLessThan20digits,
  accountNumMustMatch,
} from "utils/validations";
import { TextField } from "components/Fields";
import { CustomTooltip } from "components/DataDisplay";
import AccountNumberTooltip from "components/DataDisplay/AccountNumberTooltip";

const FORM_NAME = "fypn_bank_data_form";
const selector = formValueSelector(FORM_NAME);

const FIELDS = ["routingNum", "confirmRoutingNum", "accountNum", "confirmAccountNum"];

const routingNumMustMatch = (value, allValues) =>
  value !== allValues.routingNum ? "Routing numbers do not match" : undefined;

class Form extends PureComponent {
  componentDidMount() {
    this.handleChange();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.additionalData !== this.props.additionalData) {
      this.handleChange();
    }
  }

  handleChange = () => {
    const { additionalData, onDataChange, valid } = this.props || {};
    const filled = FIELDS.every(
      (field) => additionalData[field] !== undefined && additionalData[field] !== ""
    );
    onDataChange({
      data: additionalData,
      valid: !!valid && filled,
    });
  };

  renderField = ({ input, meta, label, placeholder }) => (
    <TextField
      type="text"
      label={label}
      placeholder={placeholder}
      meta={meta}
      inputMode="numeric"
      autoComplete="off"
      customChange={this.handleChange}
      {...input}
    />
  );

  render() {
    return (
      <div className="fypn-bank-data-form__form">
        <div className="fypn-bank-data-form__section">
          <div className="fypn-bank-data-form__section-header">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2">
              <path d="M3 21h18M3 10h18M5 6l7-3 7 3M4 10v11M20 10v11M8 14v3M12 14v3M16 14v3" />
            </svg>
            <span className="fypn-bank-data-form__section-title">Checking Account</span>
          </div>

          <div className="fypn-bank-data-form__field-row">
            <div className="fypn-bank-data-form__field">
              <Field
                name="routingNum"
                label="Routing Number *"
                placeholder="9-digit routing number"
                normalize={onlyNumbers}
                validate={[required, isNumEqual9]}
                component={this.renderField}
              />
            </div>
            <div className="fypn-bank-data-form__field">
              <Field
                name="confirmRoutingNum"
                label="Confirm Routing Number *"
                placeholder="Re-enter routing number"
                normalize={onlyNumbers}
                validate={[required, routingNumMustMatch]}
                component={this.renderField}
              />
            </div>
          </div>

          <div className="fypn-bank-data-form__field-row">
            <div className="fypn-bank-data-form__field">
              <Field
                name="accountNum"
                label="Account Number *"
                placeholder="Account number"
                normalize={onlyNumbers}
                validate={[required, isLessThan20digits]}
                component={this.renderField}
              />
            </div>
            <div className="fypn-bank-data-form__field">
              <Field
                name="confirmAccountNum"
                label="Confirm Account Number *"
                placeholder="Re-enter account number"
                normalize={onlyNumbers}
                validate={[required, isLessThan20digits, accountNumMustMatch]}
                component={this.renderField}
              />
            </div>
          </div>

          <div className="fypn-bank-data-form__help-link">
            <CustomTooltip
              title="Where can I find my account numbers?"
              text={<AccountNumberTooltip />}
            />
          </div>
        </div>
      </div>
    );
  }
}

Form.propTypes = {
  onDataChange: PropTypes.func,
};

Form.defaultProps = {
  onDataChange: () => {},
};

Form = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(Form);

Form = connect((state) => ({
  additionalData: selector(state, ...FIELDS),
}))(Form);

export default Form;
